import _styled from '@emotion/styled/base';
import { CLS_PREFIX } from './constants.js';
import { Spacing } from '../primitives/spacing.js';
import { text, border } from '@hubble/tokens/web';

const TooltipChildrenContainer = _styled('span', {
  target: "egeqp6u2"
})({
  name: "srnrf3",
  styles: "cursor:pointer;display:inline-flex;align-items:center"
} );
const getStyles = ({
  theme,
  textAlign,
  maxWidth,
  width
}) => {
  const {
    fontSize,
    fontWeight,
    lineHeight
  } = text.typesets.body.xs;
  return {
    position: 'absolute',
    display: 'block',
    [`.${CLS_PREFIX}-inner`]: {
      position: 'relative',
      maxWidth: width ? undefined : maxWidth,
      width: width,
      borderRadius: border.radius.sm,
      padding: Spacing.scale[1],
      backgroundColor: theme.colorScheme.tooltip.background.primary,
      color: theme.colorScheme.tooltip.content.primary,
      fontSize,
      fontWeight,
      lineHeight,
      textAlign
    }
  };
};
const TooltipText = _styled('span', {
  target: "egeqp6u1"
})(({
  inline
}) => inline && `
      > * {
        display: inline;
      }
    `, ";");
const IconContainer = _styled('span', {
  target: "egeqp6u0"
})(({
  inline
}) => !inline && 'display: flex;', ">", TooltipText, "+*{vertical-align:middle;margin-left:", Spacing.scale[0.5], ";}");

export { IconContainer, TooltipChildrenContainer, TooltipText, getStyles };
